<template>
  <div class="trbo-a-choice-layout">
    <div :class="classes">
      <slot />
      <div v-if="thereAreNoResults" class="trbo-a-choice-layout__list__no-results">{{ $t('wizard.noSearchResults') }}</div>
    </div>
    <div v-if="isShowingLoadMoreButton" class="trbo-a-choice-layout__actions">
      <load-more-options-button :is-disabled="isShowingAllOptions" @click="$emit('load-more-options')" />
    </div>
  </div>
</template>

<script>
// @flow

import { shouldEnableMoreOptions } from '../../../../../common/layout'

import LoadMoreOptionsButton from './LoadMoreOptionsButton.vue'

export default {
  components: {
    LoadMoreOptionsButton
  },
  props: {
    optionsNumber: {
      type: Number,
      required: true
    },
    optionSearchQuery: {
      type: String,
      default: null
    },
    isShowingAllOptions: {
      type: Boolean,
      default: false
    },
    isShowingLoadMoreButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes (): Object {
      const moreOptions = shouldEnableMoreOptions(this.optionsNumber)

      return {
        'trbo-a-choice-layout__list': true,
        'trbo-a-choice-layout__list--more-options': moreOptions,
        'trbo-a-choice-layout__list--few-options': !moreOptions
      }
    },
    thereAreNoResults (): boolean {
      return this.optionSearchQuery && this.optionsNumber === 0
    }
  }
}
</script>

<style scoped src="./choice-layout.scss" />
